import { render, staticRenderFns } from "./QueryRegionSelector.vue?vue&type=template&id=d2ea1a2e"
import script from "./QueryRegionSelector.vue?vue&type=script&lang=js"
export * from "./QueryRegionSelector.vue?vue&type=script&lang=js"
import style0 from "./QueryRegionSelector.vue?vue&type=style&index=0&id=d2ea1a2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports